export default "__VITE_ASSET__4b634921__"